import location from '@paypalcorp/instance-location';

export const appendCdnHostName = (url) => {
  return `https://${location.getCdnHostName()}${url}`;
};

export const getCdnHostName = () => {
  return `https://${location.getCdnHostName()}`;
};
